/**
 * React hook that syncs the Redux auth state to the analytics module.
 *
 * Place this in a layout or root component:
 *   useAnalyticsAuthSync();
 *
 * It reads loginStatus from the Redux store and pushes it to
 * the analytics module's imperative state so that analytics
 * functions can access login info without React hooks.
 */
"use client";

import { useEffect } from "react";
import { useAppSelector, selectLoginStatus } from "@repo/web-store";
import {
	setAnalyticsLoginStatus,
	setAnalyticsTokenPresent,
} from "../state/loginState";
import { COMMON_SSO_ACCESS_TOKEN } from "@repo/shared-utils/sso.constants";
import { isBrowser } from "@repo/shared-utils/common-utils";

export const useAnalyticsAuthSync = (): void => {
	const loginStatus = useAppSelector(selectLoginStatus);

	useEffect(() => {
		setAnalyticsLoginStatus(loginStatus);

		// Also sync token presence
		if (isBrowser()) {
			try {
				const token = globalThis.window.localStorage?.getItem(COMMON_SSO_ACCESS_TOKEN);
				setAnalyticsTokenPresent(Boolean(token && token !== "dummy"));
			} catch {
				setAnalyticsTokenPresent(false);
			}
		}
	}, [loginStatus]);
};
